// A stable accent colour for a card, chosen from the site's own palette by name.
const ACCENTS = [
    { bar: "#C89B3C", tint: "rgba(200,155,60,0.14)" },   // gold
    { bar: "#FF758F", tint: "rgba(255,117,143,0.13)" },  // rose
    { bar: "#B82332", tint: "rgba(184,35,50,0.20)" },    // crimson
    { bar: "#9B7BC9", tint: "rgba(155,123,201,0.16)" },  // plum
  ];
  
  export function accentFor(key = "") {
    let h = 0;
    for (const ch of String(key)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
    return ACCENTS[h % ACCENTS.length];
  }